module.exports = __webpack_public_path__ + "img/main_logo.0cd595a4.svg";